import "./Home.css";
import { motion, easeOut } from "framer-motion";
import { useTranslation } from "react-i18next";
import Header from "../sections/Header";
import About from "../sections/About";
import Clients from "../sections/Clients";
import CaseStudies from "../sections/CaseStudies";
import Process from "../sections/Process";
import SingleOrderBanner from "../sections/SingleOrderBanner";
import Pricing from "../sections/Pricing";
import Invitation from "../sections/Invitation";
import Footer from "../sections/Footer";

function Headline() {
  const { t } = useTranslation();
  const sectionVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: easeOut },
    },
  };

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      variants={sectionVariants}
    >
      <div className="headline">
        <h2>
          {t("home.headlineMain")}
          <br />
          {t("home.headlineSub")}
        </h2>
      </div>
    </motion.section>
  );
}

function Home() {
  return (
    <>
      <Header />
      <CaseStudies />
      <Headline />
      <About />
      <Clients />
      <SingleOrderBanner />
      <Process />
      <Pricing />
      <Invitation />
      <Footer />
    </>
  );
}

export default Home;
